export default "__VITE_ASSET__DMI_vDJs__"